<template>
  <div class="comp-title"
    v-bind:class="dataId"
  >
    <div class="component-container body-wrap">
      <div class="inner">
        <div class="ques-wrap lg-50 md-100 sm-100 xs-100"
          v-if="false"
        >
          <p class="title-style"
            v-bind:tabIndex="(enableTab) ? 1 : -1"
            v-focus="(initFocus && !hasAnswer)"
            @focus="initFocus = true"
            @blur="initFocus = false"
          >
            {{content.data.title}}
          </p>
          <div class="text-wrap">
            <div class="bubble">
              <p class="desc-style"
                v-bind:tabIndex="(enableTab) ? 2 : -1"
                v-for="(text, index) in content.data.description"
                v-bind:key="index"
              >
                {{text}}
              </p>
            </div>
          </div>
        </div>

        <div class="char-wrap lg-100 md-100 sm-100 xs-100">
          <img class=""
            v-for="(path, index) in content.data.imagePath"
            v-bind:key="index"
            v-bind:src="require('../../assets/' + path)"
          >
        </div>
        <div class="control-wrap clearfix">
          <div class="categories">
            <img class=""
              v-for="(path, index) in content.data.imagePath2"
              v-bind:key="index"
              v-bind:src="require('../../assets/' + path)"
            >
          </div>
          <div role="button" class="start-button"
            v-bind:tabIndex="(enableTab) ? 4 : -1"
            v-for="(actionItems, key) in content.data.actions"
            v-bind:key="key"
            v-on:click="randomizeAndGo"
          >
          <p class="">
            {{actionItems.label}}
            <span><br>{{actionItems.description}}</span>
          </p>
          <img class=""
            v-for="(path, index) in actionItems.iconPath"
            v-bind:key="index"
            v-bind:src="require('../../assets/' + path)"
          >
          </div>
          <div v-if="false" class="drag-wrap center-content">
            <button
              v-bind:tabIndex="(enableTab) ? 4 : -1"
              v-for="(actionItems, key) in content.data.actions"
              v-bind:key="key"
              v-on:click="goNext"
            >
              {{actionItems.label}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { focus } from 'vue-focus'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'TitleSlide',
  directives: { focus: focus },
  data () {
    return {
      initFocus: false,
      enableTab: true
    }
  },
  props: {
    dataId: {
      type: String,
      required: true
    },
    displayed: {
      type: Boolean,
      default: true
    },
    isFocus: {
      type: Boolean,
      required: false,
      dafault: false
    }
  },
  computed: {
    ...mapState({
      interactiveData: state => state.interactiveData,
      component: state => state.componentData
    }),
    content () {
      return this.$store.getters.getData(this.dataId)
    },
    themes () {
      return this.$store.getters.getThemes(this.content.data.category)
    }
  },
  methods: {
    ...mapMutations([
      'randomizeComponent',
      'setScoreData',
      'goToSlide'
    ]),
    randomizeAndGo (keyword) {
      this.randomizeComponent(keyword)
      this.setScoreData()
      this.goToSlide(1)
      this.$playSound(require('../../assets/audio/zapsplat_multimedia_click_001_19367.mp3'))
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./style.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/title-slide/TitleSlide.vue